export default __webpack_public_path__ + "static/media/Green geode2.b81a0605.jpg";